import React, { useContext } from "react";
import { Language } from "../../../App";
import { MdShoppingBag, MdBookmark, MdSchool } from "react-icons/md";

const CoursesTabMenuCard = React.memo(function CoursesTabMenuCard({
  title,
  count = 0,
  active,
  onClick,
  type,
}) {
  const { lang } = useContext(Language);

  const lowerTitle = (title || "").toLowerCase();
  const isSaved = type === "saved" || lowerTitle.includes("saved") || lowerTitle.includes("guardado");
  const isCreated = type === "created" || lowerTitle.includes("my") || lowerTitle.includes("mis");

  const getIcon = () => {
    if (isSaved) {
      return <MdBookmark size={24} />;
    }
    if (isCreated) {
      return <MdSchool size={24} />;
    }
    return <MdShoppingBag size={24} />;
  };

  const getIconClass = () => {
    if (isSaved) return "cr-stat-icon-saved";
    if (isCreated) return "cr-stat-icon-created";
    return "cr-stat-icon-purchased";
  };

  const getCardClass = () => {
    if (isSaved) return "cr-stat-block-saved";
    if (isCreated) return "cr-stat-block-created";
    return "cr-stat-block-purchased";
  };

  return (
    <div
      className={`cr-stat-block ${getCardClass()}${active ? " active" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick && onClick();
        }
      }}
    >
      <div className={`cr-stat-icon-wrap ${getIconClass()}`}>
        {getIcon()}
      </div>

      <div className="cr-stat-info">
        <span className="cr-stat-label">{title}</span>
        <div className="cr-stat-count-row">
          <span className="cr-stat-count">{count}</span>
          <span className="cr-stat-sub">{lang.courses || "Courses"}</span>
        </div>
      </div>
    </div>
  );
});

export default CoursesTabMenuCard;
